<template>
<div class="chapter">
<div class="inner_page">
<div id="Frontmatter">
<p class="fig-caption1a">Cover: <b>What was to become the South London subsidiary of LBL became synonymous with the production L, operating them for just short of 19 years. On 7 May 1988 Croydon’s L 250 (D250 FYM) and L 201 (D201 FYM) pass through Thornton Heath. Exemplifying the need for most South London garages’ Ls to share their routes with older types, a DMS can just be seen creeping up behind.</b> <i>Malc McDonald</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Frontmatter.vue?83d4a548